<template>
    <div>
        <div v-if="!isMobileFlag" class="content_div" style="background-color: white;">
            <el-container>
                <div>
                    <top-header></top-header>
                </div>
                <el-main style="width: 85%;margin:0 7.5%;">
                    <router-view></router-view>
                </el-main>
                <el-footer style="height: auto;width: 85%;margin:0 7.5%;">
                    <bottom></bottom>
                </el-footer>
            </el-container>
        </div>
        <!--手机端-首页-->
        <div v-if="isMobileFlag">
            <el-container>
                <el-header>
                    <mobile-top></mobile-top>
                </el-header>
                <el-main>
                    <router-view></router-view>
                </el-main>
                <el-footer>
                    <mobile-bottom></mobile-bottom>
                </el-footer>
            </el-container>

            <!-- 手机端回到顶部：滚动超过一屏后出现，点击平滑回顶 -->
            <transition name="fade">
                <div v-show="showBackTop" class="back-top" @click="backTop" role="button" aria-label="Back to top">
                    <i class="el-icon-top"></i>
                </div>
            </transition>
        </div>
    </div>


</template>
<script>
import TopHeader from "@/components/layout/TopHeader";
import Bottom from "@/components/layout/Bottom";
import MobileTop from "@/components/mobile/MobileTop.vue";
import MobileHomeBanana from "@/components/mobile/MobileHomeBanana.vue";
import MobileBottom from "@/components/mobile/MobileBottom.vue";

export default {
    name: "Layout",
    created() {

    },
    mounted() {
        let flag =this.$isMobile()
        // this.$message.success(flag);
        this.isMobileFlag = flag;
        if (flag) {
            window.addEventListener('scroll', this.handleScroll, {passive: true});
            this.handleScroll();
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    components: {
        MobileHomeBanana,
        MobileTop,
        MobileBottom,
        Bottom,
        TopHeader
    },
    methods: {
        handleScroll() {
            this.showBackTop = (window.scrollY || window.pageYOffset || 0) > 300;
        },
        backTop() {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },
    },
    data() {
        return {
            total: 0,
            dataList: [],
            query: {},
            isMobileFlag: false,
            showBackTop: false,
        }
    }
}
</script>
<style scoped>
::v-deep .el-header {
    margin: 0;
    padding: 0;
    /* 手机端顶栏吸顶：随内容滚动时固定在顶部 */
    position: sticky;
    top: 0;
    z-index: 1000;
}

.el-footer {
    padding: 0;
}
::v-deep .el-card__body, .el-main{
    padding: 0;
}

/* 手机端回到顶部悬浮按钮（仅手机端出现） */
.back-top {
    position: fixed;
    right: 16px;
    bottom: 24px;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: var(--brand, #246543);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, .28);
    z-index: 120;
    cursor: pointer;

    &:active {
        transform: scale(.94);
    }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .25s ease;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
